/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import $ from 'jquery';
import TagManager from 'react-gtm-module';

function Caption03() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		//$(".btn_popup").off('click');
		//$(".btn_close").off('click');
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])
	return (
		<>
			<div className="popup" id="cb_pop23">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_23">KKBOX</h4>
								<p>「KKBOX」華人世界最大的線上音樂網，手機電腦都可以使用，只要能上網，就能聽音樂。i寶貝可以用歌手、歌名、排行榜、音樂風格點歌，還可查詢播放的歌曲歌名。近期更獨家推出「台語點歌」及「聲控打造個人歌單」功能，聲控編輯、收藏、播放個人專屬歌單真簡單！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，來點流行音樂</span></p></li>
									<li><p><span>i寶貝，我想聽西洋排行榜</span></p></li>
									<li><p><span>i寶貝，我想聽運動的音樂</span></p></li>
									<li><p><span>i寶貝，這是誰的歌</span></p></li>
									<li><p><span>i寶貝，收藏這首歌/幫我加到我的最愛</span></p></li>
									<li><p><span>i寶貝，播放我的最愛/我的收藏</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop25">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_25">童書夢工廠</h4>
								<p>「童書夢工廠」收錄最受歡迎的世界經典童話故事!疲累了一整天，實在沒體力講故事給孩子聽，就有請i寶貝來幫個忙吧!(書單請參閱官網的<a target="_blank" style={{ "display": "inline" }} href="https://www.funpark.com.tw/smartfun-web/nweb2014/book_list_mbrlevel_for_middleware.jsp?mbrlevel=20180223143358395001" rel="noreferrer">內容清單</a>)</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我想聽故事</span></p></li>
									<li><p><span>i寶貝，聽個白雪公主的故事</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop26">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_26">大家說英語</h4>
								<p>「大家說英語」是以主題結合會話，針對初級程度的學習者，運用不同主題情境對話與專業老師講解，教導不同的英文技巧，並讓學習者在不斷聆聽學習中，融入英語情境並自然而然地知道如何運用在日常生活當中，強化英語聽說基礎。現在透過i寶貝可以免費聽當天的大家說英語課程哦！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要聽英文</span></p></li>
									<li><p><span>i寶貝，我要聽大家說英語</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop27">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_27">愛播聽書FM</h4>
								<p>i寶貝精選「愛播聽書FM」8個最暢銷類別，超過200本書並持續更新，滿足全家老少對於生活、學習、娛樂全方面的需求!即刻啟用享90天免費試聽(僅限首次啟用)(「愛播聽書FM」服務由內容提供者針對中華電信智慧音箱設計，實際內容可參考音箱內所承載的內容並實際播出而定，書單請參閱官網的<Link to={"/container/caption/Caption0302"} style={{ display: "inline" }}>內容清單</Link>)</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要聽黃子佼演藝圈的生存之道</span></p></li>
									<li><p><span>i寶貝，我要聽張艾嘉的音樂故事曖魅</span></p></li>
									<li><p><span>i寶貝，我要聽孫越叔叔的故事大喇叭4</span></p></li>
									<li><p><span>i寶貝，我要聽教你背新多益單字上5會議</span></p></li>
									<li><p><span>i寶貝，我要聽EFT情緒釋放技巧</span></p></li>
									<li><p><span>i寶貝，我要聽賴佩霞快樂家不費力的領導</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop34">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_34">SoundOn Podcast</h4>
								<p>「SoundOn」是台灣最大的 Podcast 公司，提供方便齊全的台灣 Podcasts 探索與聆聽，擁有精彩多元的優質自製節目，是聽眾熱愛的排行榜常客。想用零碎時間學新知？想聽人閒聊放空或被魔性笑聲給治癒？從明星藝人、專業職人到有著獨特觀點的意見領袖，什麼千奇百怪的主題都有，任君挑選一定有你的最愛！快跟 i寶貝說「我要聽Podcast」！找到頻率最對的聲音節目，陪伴你的時時刻刻！</p>
							</div>
						</div>
						<div className="cb_tit">使用範例</div>
						<div className="cb_dialog">
							<ul>
								<li><p><span>i寶貝，我要聽Podcast</span></p></li>
								<li><p><span>i寶貝，我要聽「報導者」Podcast</span></p></li>
								<li><p><span>i寶貝，播放「百靈果」Podcast最新一集</span></p></li>
								<li><p><span>i寶貝，推薦我「投資類」的Podcast</span></p></li>
								<li><p><span>i寶貝，我想聽「今日新聞」Podcast</span></p></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop35">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_35">i聽聽精選Podcast</h4>
								<p>「i聽聽 iListen」為臺灣第一綜合性有聲內容平台，為你匯聚了過去─現在─未來，最豐富的知識、經典與有趣內容，擁有超過3萬集、橫跨多元領域的有聲書、Podcast、線上課程與語音新聞，打造有聲內容聽覺百匯。i聽聽將成為你在奔忙腳步中，緩緩豐富自我、充實生活的最佳夥伴。現在透過i寶貝音箱可以收聽到精選Podcast的20集節目內容，與我們一同按下啟動閱聽新生活的播放鍵，讓我們一起愛聽聽！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，播放i聽聽比利大視野</span></p></li>
									<li><p><span>i寶貝，我要聽i聽聽Podcast</span></p></li>
									<li><p><span>i寶貝，我要聽i聽聽「侯昌明」的節目</span></p></li>
									<li><p><span>i寶貝，播放i聽聽「鴨子一窩瘋」的Podcast</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop42">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_42">童書夢工廠-補充包</h4>
								<p>收錄小魯文化、親子天下等多家童書出版社的暢銷兒童有聲書，有聲書月月更新不間斷，最新、最熱門的兒童有聲書盡在【童書夢工廠-補充包】，(書單請參閱官網的<a target="_blank" style={{ "display": "inline" }} href="https://www.funpark.com.tw/smartfun-web/nweb2014/book_list_mbrlevel_for_middleware.jsp?mbrlevel=20210312130759007001" rel="noreferrer">內容清單</a>)</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我想聽故事</span></p></li>
									<li><p><span>i寶貝，聽個小紅帽的故事</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop45">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">音樂故事</div>
								<h4 className="cb_45">Live互動英語</h4>
								<p>Live互動英語適合全民英檢中級的學生，主題以生活、實用為主。學習目標國高中生到成人的一般生活英語會話，教材貼近日常生活，實用英語輕鬆學。真人課程講解、搭配音箱創造英聽環境，開口說不再困難。情境式會話，體驗如在國外學英語的驚人效果。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我想聽Live互動英語</span></p></li>
									<li><p><span>i寶貝，幫我播放Live英語</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">服務說明 - 音樂故事</h2>
							<div className="content_box caption_box">
								<div className="cb_item flex_set">
									<div className="cb_box flex_box"><a id="cb_pop23" className="btn_popup cb_23">KKBOX</a></div>
							
									<div className="cb_box flex_box"><a id="cb_pop25" className="btn_popup cb_25">童書夢工廠</a></div>
									{/*<div className="cb_box flex_box"><a id="cb_pop45" className="btn_popup cb_45">Live互動英語</a></div>*/}
									<div className="cb_box flex_box"><a id="cb_pop26" className="btn_popup cb_26">大家說英語</a></div>
									{/*<div className="cb_box flex_box"><a id="cb_pop27" className="btn_popup cb_27">愛播聽書FM</a></div>*/}
									<div className="cb_box flex_box"><a id="cb_pop34" className="btn_popup cb_34">SoundOn Podcast</a></div>
									<div className="cb_box flex_box"><a id="cb_pop35" className="btn_popup cb_35">i聽聽精選Podcast</a></div>
								</div>
								<div className="cb_dialog">
									<ul>
										<li className="flex_set cb_23"><p className="flex_box"><span>i寶貝，這首歌幫我加到我的最愛。</span></p></li>
										<li className="flex_set cb_23"><p className="flex_box"><span>i寶貝，播放我的最愛。</span></p></li>
										<li className="flex_set cb_24"><p className="flex_box"><span>i寶貝，我要聽兒歌。</span></p></li>
										<li className="flex_set cb_25"><p className="flex_box"><span>i寶貝，我想聽故事。</span></p></li>
									</ul>
									<ul>
										<li className="flex_set cb_25"><p className="flex_box"><span>i寶貝,幫我播放睡美人。</span></p></li>
										{/*<li className="flex_set cb_45"><p className="flex_box"><span>i寶貝，幫我播放Live英語</span></p></li>*/}
										<li className="flex_set cb_26"><p className="flex_box"><span>i寶貝，我要聽大家說英語。</span></p></li>
										{/*<li className="flex_set cb_27"><p className="flex_box"><span>i寶貝，我要聽有聲書</span></p></li>*/}
										<li className="flex_set cb_34"><p className="flex_box"><span>i寶貝，我要聽Podcast</span></p></li>
										<li className="flex_set cb_35"><p className="flex_box"><span>i寶貝，播放i聽聽比利大視野</span></p></li>
									</ul>
								</div>
							</div>
							<div className="btn_main btn_other">
								<Link to={"/container/caption/Caption0301"} >查看音樂故事清單</Link>
								<a href="/container/soundon" target="_blank">Podcast專區</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption03;